// extracted by mini-css-extract-plugin
export default {"colorIcon":"Nc5Uu","emojiIcon":"kJY__","icon":"xY7iX undefined"};